import React, { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { billingApi } from '../../api';
import { useToast } from '../../hooks/use-toast';

export const MemberRate = ({ member, onSaved }) => {
  const { toast } = useToast();
  const [value, setValue] = useState(member.hourlyRate ?? '');
  const [busy, setBusy] = useState(false);
  const dirty = String(value) !== String(member.hourlyRate ?? '');
  const save = () => {
    setBusy(true);
    billingApi.setMemberRate(member.id, value === '' ? null : Number(value))
      .then(() => { toast({ title: 'Rate saved', description: `${member.name}: ${value === '' ? 'firm default' : `R ${value}/h`}` }); onSaved?.(); })
      .catch((e) => toast({ title: 'Could not save rate', description: e?.response?.data?.detail || 'Try again.', variant: 'destructive' }))
      .finally(() => setBusy(false));
  };
  return (
    <div className="flex items-center gap-1 mr-2" data-testid={`member-rate-${member.id}`}>
      <span className="text-xs text-stone-500">R</span>
      <input type="number" min="0" step="10" value={value} placeholder="default" onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && dirty) save(); }}
        className="w-20 h-8 rounded-md border border-stone-200 px-2 text-sm text-right focus:outline-none focus:ring-2 focus:ring-emerald-600"
        data-testid={`member-rate-input-${member.id}`} aria-label={`Hourly rate for ${member.name}`}/>
      <span className="text-xs text-stone-500">/h</span>
      {dirty && (
        <button type="button" onClick={save} disabled={busy} className="p-1 text-emerald-800 hover:bg-emerald-50 rounded" data-testid={`member-rate-save-${member.id}`}>
          {busy ? <Loader2 size={14} className="animate-spin"/> : <Check size={14}/>}
        </button>
      )}
    </div>
  );
};
